
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { SegmentedControl, SegmentedControlItem, Callout, Spinner, Badge, Category, Icon, Size } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Segmented Control`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { SegmentedControl, SegmentedControlItem } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<SegmentedControl>
  <SegmentedControlItem active text="First choice" />
  <SegmentedControlItem text="Second choice" />
  <SegmentedControlItem text="Third choice" />
</SegmentedControl>`} component={SegmentedControl} mdxType="Playground">
  <SegmentedControl mdxType="SegmentedControl">
    <SegmentedControlItem active text="First choice" mdxType="SegmentedControlItem" />
    <SegmentedControlItem text="Second choice" mdxType="SegmentedControlItem" />
    <SegmentedControlItem text="Third choice" mdxType="SegmentedControlItem" />
  </SegmentedControl>
</Playground>
<h4>{`SegmentedControl Item`}</h4>
<Playground __position={1} __code={`<SegmentedControlItem text="I'm an item" />`} component={SegmentedControlItem} mdxType="Playground">
  <SegmentedControlItem text="I'm an item" mdxType="SegmentedControlItem" />
</Playground>
<p>{`You can also give leading and trailing to items, and disable them:`}</p>
<Playground __position={2} __code={`<SegmentedControl>
  <SegmentedControlItem active text="First option" trailing={<Spinner size={Size.SMALL}  />} />
  <SegmentedControlItem text="Second option" trailing={<Badge value={5} category={Category.DANGER} />} />
  <SegmentedControlItem text="Third option" disabled leading={<Icon name="brand-id" />} />
</SegmentedControl>`} mdxType="Playground">
  <SegmentedControl mdxType="SegmentedControl">
    <SegmentedControlItem active text="First option" trailing={<Spinner size={Size.SMALL} mdxType="Spinner" />} mdxType="SegmentedControlItem" />
    <SegmentedControlItem text="Second option" trailing={<Badge value={5} category={Category.DANGER} mdxType="Badge" />} mdxType="SegmentedControlItem" />
    <SegmentedControlItem text="Third option" disabled leading={<Icon name="brand-id" mdxType="Icon" />} mdxType="SegmentedControlItem" />
  </SegmentedControl>
</Playground>
<p><strong parentName="p">{`Old Examples`}</strong></p>
<Callout category={Category.DANGER} mdxType="Callout">
  Part of the API has been deprecated, please use the new one described above instead.
</Callout>
<br />
<Playground __position={5} __code={`<ControlledField component={
  <SegmentedControl
    options={[{
      label: 'First choice',
      value: 'first',
    }, {
      label: 'Second choice',
      value: 'second',
    }, {
      label: 'Third',
      value: 'third',
    }]} />
} />`} mdxType="Playground">
  <ControlledField component={<SegmentedControl options={[{
        label: 'First choice',
        value: 'first'
      }, {
        label: 'Second choice',
        value: 'second'
      }, {
        label: 'Third',
        value: 'third'
      }]} mdxType="SegmentedControl" />} mdxType="ControlledField" />
</Playground>
<p>{`You can also have a number value displayed within each control through `}<inlineCode parentName="p">{`bullet`}</inlineCode>{`. Each option can also be `}<inlineCode parentName="p">{`disabled`}</inlineCode>{`.`}</p>
<Playground __position={6} __code={`<ControlledField component={
  <SegmentedControl
    options={[{
      label: 'First choice',
      value: 'first',
      bullet: 4,
    }, {
      label: 'Second choice',
      value: 'second',
      bullet: 23,
      disabled: true,
    }, {
      label: 'Third',
      value: 'third',
      bullet: 123,
      loading: true,
    }]} />
} />`} mdxType="Playground">
  <ControlledField component={<SegmentedControl options={[{
        label: 'First choice',
        value: 'first',
        bullet: 4
      }, {
        label: 'Second choice',
        value: 'second',
        bullet: 23,
        disabled: true
      }, {
        label: 'Third',
        value: 'third',
        bullet: 123,
        loading: true
      }]} mdxType="SegmentedControl" />} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;